import { Lead } from "@/components/shared/lead/Lead";
import { ModuleType } from "@/lib/constants";
import styles from "./LandingBanner.module.css";
import Image from "next/image";
import { ILandingPageData } from "@/interfaces/ILandingPage";
import { useGlobalContext } from "@/lib/context";

type props = {
    data: ILandingPageData['bannerSection']
}
export function LandingBanner({ data }: props) {
    const { props: { pageURL } } = useGlobalContext();
    return (
        <section>
            <div className={styles.campginpabannerm}>
                <div className={styles.cammainBannering}>
                    <Image width={1440} height={680} className="img-responsive" src={pageURL.includes("/lp/home-interior-designer/") ? `/assets/images/unverifiedBannerWeb.png` : data.imageweb} alt="campaign" />
                </div>
                <div className={styles.campingbannermob}>
                    <Image width={360} height={400} className="img-responsive" src={pageURL.includes("/lp/home-interior-designer/") ? `/assets/images/unverifiedBannerRes.png` : data.imageMobile} alt="campinbannermob" />
                </div>
                <div className="container1350">
                    <div className={styles.campainLedtextbox}>
                        {
                            pageURL.includes("/lp/home-interior-designer/") ?
                                <>
                                    <div className={styles.campTxtbox}>
                                        <span className={styles.capmBoxtext}>{data.headingText}</span>
                                        <span className={styles.comBoxlowtex}>{data.subHeadingText}</span>
                                    </div>
                                    <div className={styles.bookMyconbtbox}>
                                        <button className="btnPrimery" id="openExitIntentForm">{data.leadBtnText}</button>
                                    </div>
                                </>
                                :
                                <>
                                    <div className={styles.campTxtbox}>
                                    </div>
                                    <div className={styles.bookMyconbtbox}>
                                    </div></>
                        }
                        <div className={styles.campingLeadbox}>
                            <div className={`${styles.exitnewFormBox} popup`}>
                                <Lead ModuleType={ModuleType.INTERIOR} Title="Every Home Has a Unique Inside Story, Meet the Designer" ButtonText={data.leadBtnText} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}